import React from 'react';
import { QueryKey } from 'react-query';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterProjectStatusValue,
  UniversalFilterProjectStatusModes,
  UniversalFilterProjectStatusOnChange
} from './UniversalFilterProjectStatus.types';

import { useUniversalFilterProjectStatus } from './hooks/useUniversalFilterProjectStatus';

import { ProjectsStatusesMultiSelect } from '../../../../../main/projects/helpers/ProjectsStatusesMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterProjectStatusProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterProjectStatusValue;
  i18nName: I18nText;
  autoFocus?: boolean;
  onChange: UniversalFilterProjectStatusOnChange;
}

function UniversalFilterProjectStatus({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  autoFocus,
  onChange
}: UniversalFilterProjectStatusProps) {
  const { modeOptions, filterState, handleModeChange, handleStatusesChange } =
    useUniversalFilterProjectStatus({
      filterStateCacheKey,
      filterValue,
      onChange
    });

  return (
    <UniversalFilterTemplate<UniversalFilterProjectStatusModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      <ProjectsStatusesMultiSelect
        key={filterState.mode}
        value={filterState.statuses || []}
        autoFocus={autoFocus}
        onChange={handleStatusesChange}
      />
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterProjectStatus;
